/**
 * Page de test pour le dashboard de monitoring
 * Page simple pour valider l'intégration du monitoring avec données mockées
 * @author Cascade (Tech Lead)
 * @date 2025-07-09
 */

import React from 'react';
import { MonitoringDashboard } from '../features/monitoring';

const MonitoringPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <MonitoringDashboard
        refreshInterval={30}
        autoRefresh={true}
        className="monitoring-dashboard"
      />
    </div>
  );
};

export default MonitoringPage;
